export default "__VITE_ASSET__664093e9__"